import styled from "styled-components";
import { ReactComponent as Info } from "../../../../assets/images/svg/info.svg";

export const InfoIcon = styled(Info)`
  margin-left: 14px;
  position: relative;
  right: 10px;
`